import { useState } from "react";
import { Link } from "react-router-dom";
import { Rocket, Flask, Flag, HardDrives, X, ArrowRight } from "@phosphor-icons/react";

// First-run tip strip shown once on the home feed right after signup. The flag
// is set by LoginPage on successful register and cleared the moment the user
// dismisses it or taps a quick-start link.
const KEY = "hc_show_welcome";

const TIPS = [
    { to: "/labs", icon: Flask, label: "Vulnerable Labs", desc: "218 hands-on targets" },
    { to: "/ctf", icon: Flag, label: "CTF Arena", desc: "solve · submit · climb" },
    { to: "/box", icon: HardDrives, label: "Attack Box", desc: "kali in your browser" },
];

export default function SignupWelcomeStrip() {
    const [show, setShow] = useState(() => {
        try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
    });
    if (!show) return null;
    const dismiss = () => {
        try { localStorage.removeItem(KEY); } catch { /* noop */ }
        setShow(false);
    };
    return (
        <div data-testid="signup-welcome-strip"
             className="relative border border-cyan-500/40 bg-gradient-to-r from-cyan-500/10 via-violet-500/5 to-transparent rounded-sm p-4 sm:p-5">
            <button onClick={dismiss} data-testid="signup-welcome-dismiss"
                    className="absolute top-2.5 right-2.5 text-slate-500 hover:text-slate-200 p-1" aria-label="Dismiss">
                <X size={15} />
            </button>
            <div className="flex items-center gap-2 mb-3 pr-6">
                <Rocket size={18} weight="duotone" className="text-cyan-300 shrink-0" />
                <h2 className="text-sm sm:text-base font-bold text-slate-100" style={{ fontFamily: "'Space Grotesk', 'Chivo', sans-serif" }}>
                    Welcome aboard — here&apos;s where hackers start
                </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-2.5">
                {TIPS.map(({ to, icon: Icon, label, desc }) => (
                    <Link key={to} to={to} onClick={dismiss} data-testid={`signup-welcome-${to.slice(1)}`}
                          className="group flex items-center gap-3 border border-white/10 hover:border-cyan-500/60 bg-white/[0.02] hover:bg-cyan-500/5 rounded-sm p-3 transition-colors">
                        <div className="shrink-0 w-9 h-9 rounded-sm border border-cyan-500/40 bg-cyan-500/10 flex items-center justify-center">
                            <Icon size={18} weight="duotone" className="text-cyan-300" />
                        </div>
                        <div className="min-w-0 flex-1">
                            <div className="text-sm font-bold text-slate-100 truncate">{label}</div>
                            <div className="text-[10px] uppercase tracking-widest font-mono text-slate-500 truncate">{desc}</div>
                        </div>
                        <ArrowRight size={13} className="shrink-0 text-cyan-400 group-hover:translate-x-0.5 transition-transform" />
                    </Link>
                ))}
            </div>
        </div>
    );
}
